interface IBaseEntity {
  id: number;
}

export interface IFormWarranty {
  warranty_type: string;
  name: string;
  surname: string;
  sex: string;
  email: string;
  mobile_no: string;
  car_id: string;
  car_province: string;
  car_new: number;
  car_new_brand: string;
  car_new_model: string;
  car_new_color: string;
  tire_brand: string;
  tire_install_date: string;
  tire_service_center_name: string;
  tire_from_store: number;
  tire_store_name: string;
  tire_store_address: string;
  tire_store_province: string;
  tire_store_postcode: string;
  tire_store_by_service_center_name: string;
  rate_the_service: string;
  slip_image: string;
  did_you_know: string;
  access_media: string;
  warranty_term_accept: number;
  agreement_accept: number;
}
export class FormWarranty implements IFormWarranty {
  warranty_type = '';
  name = '';
  surname = '';
  sex = '';
  email = '';
  mobile_no = '';
  car_id = '';
  car_province = '';
  car_new = 0;
  car_new_brand = '';
  car_new_model = '';
  car_new_color = '';
  tire_brand = '';
  tire_install_date = ''; // Default to the current date
  tire_service_center_name = '';
  tire_from_store = 0;
  tire_store_name = '';
  tire_store_address = '';
  tire_store_province = '';
  tire_store_postcode = '';
  tire_store_by_service_center_name = '';
  rate_the_service = '';
  slip_image = '';
  did_you_know = '';
  access_media = '';
  warranty_term_accept = 0;
  agreement_accept = 0;

  // Add a constructor if you want to allow initialization with specific values
  // constructor(initialValues: Partial<IFormWarranty> = {}) {
  //   Object.assign(this, initialValues); // Assign initial values to the class properties
  // }
}
